import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../../services/authentication/login.service';

@Component({
  selector: 'app-repohome',
  templateUrl: './repohome.component.html',
  styleUrls: ['./repohome.component.css']
})
export class RepohomeComponent implements OnInit {

  	menu:any;
  	permissions = [];

	constructor(public auth: LoginService) {}

	ngOnInit() {
		this.menu = [
			{name:'Maestro Ruta', desc:'Reporte Maestro Ruta', icon:'fas fa-route', url:'/masterroute', perm: 'SALES-REP-MASTER_ROUTE'},
			{name:'Pedidos Pendientes', desc:'Reporte Pedidos Pendientes', icon:'fas fa-file-invoice-dollar', url:'/pendingorders', perm: 'SALES-REP-PEND_ORDERS'},
			{name:'Cumplimiento Ruta', desc:'Reporte cumplimiento de ruta diaria', icon:'fas fa-medal', url:'/routeaccomplish', perm: 'SALES-REP-ROUTE_ACCOMP'},
      {name:'Tablero de Control', desc:'Tablero de Control', icon:'fas fa-border-all', url:'/controlpanel', perm: 'SALES-REP-TABLERO_CONTROL'},
      {name:'Ventas por Cliente', desc:'Reporte ventas por cliente', icon:'fas fa-user-tie', url:'/salesbyclient', perm: 'SALES-REP-SALES_BY_CLIENT'},
      {name:'Ventas por Categoría', desc:'Reporte ventas por categoría', icon:'fas fa-tags', url:'/salesbycategory', perm: 'SALES-REP-SALES_BY_CATEGORY'},
      {name:'Ventas por Cliente - Categoría', desc:'Reporte ventas por cliente y categoría', icon:'fas fa-user-tag', url:'/salesbyclientcategory', perm: 'SALES-REP-SALES_BY_CLIENT_CATEGORY'},
      {name:'Análisis Cartera', desc:'Anális Cartera por Cliente', icon:'fas fa-briefcase', url:'/portfolioanalysis', perm: 'SALES-REP-PORTFOLIO_ANALYSIS'},
      {name:'Tablero de Control Supervisor', desc:'Tablero de Control', icon:'fas fa-border-all', url:'/controlpanelsuperv', perm: 'SALES-REP-TABLERO_CONTROL_SUPERV'},
      {name:'Cumplimiento Ruta Supervisor', desc:'Reporte cumplimiento de ruta diaria', icon:'fas fa-medal', url:'/routeaccomplishsuperv', perm: 'SALES-REP-ROUTE_ACCOMP_SUPERV'},
      {name:'Ventas por Vendedor - Categoría', desc:'Reporte ventas por vendedor y categoría', icon:'fas fa-user-tag', url:'/salesbysellercategory', perm: 'SALES-REP-SALES_BY_SELLER_CATEGORY_SUPERV'},
      {name:'Análisis Cartera Supervisor', desc:'Anális Cartera por Vendedor', icon:'fas fa-briefcase', url:'/portfolioanalysissuperv', perm: 'SALES-REP-PORTFOLIO_ANALYSIS_SUPERV'},
      {name:'Tablero de Control Jefes', desc:'Tablero de Control Jefes', icon:'fas fa-border-all', url:'/controlpanelchief', perm: 'SALES-REP-TABLERO_CONTROL_CHIEF'},
      {name:'Ventas por Supervisor - Categoría', desc:'Reporte ventas por supervisor y categoría', icon:'fas fa-user-tag', url:'/salesbysupervcategory', perm: 'SALES-REP-SALES_BY_SUPERV_CATEGORY_CHIEF'},
      {name:'Análisis Cartera Jefe', desc:'Anális Cartera por Supervisor', icon:'fas fa-briefcase', url:'/portfolioanalysischief', perm: 'SALES-REP-PORTFOLIO_ANALYSIS_CHIEF'},
      {name:'Georeferencia', desc:'Matriculación Clientes', icon:'fas fa-map-marker-alt', url:'/customers', perm: 'SALES-CLIENTS'},
      {name:'Ubicación', desc:'Ubicación de Clientes', icon:'fas fa-route', url:'/customerscollectors', perm: 'SALES-REP-COLLECTORS'}
		];

		this.auth.getPermissions().then(x => {
            this.permissions = x;
            
        });
	}

	hasPermission(str:string){
        if( this.permissions.indexOf(str) > -1 ){
            return true;
        }
        else{
            return false;
        }
    }

}
